import { sucursalesGet } from "#core/Services/api_sucursales"
import { useApi } from "#hooks/useApi"
import { useEffect, useMemo } from "react"
import InputAutocomplete from "./InputAutocomplete"
/**
 *
 * @param {*} props
 * @param {boolean} props.manager
 * @param {number} props.value
 * @param {boolean}props.disabled
 * @param {boolean}props.fullWidth
 * @param {string}props.minWidth
 * @returns
 */
const InputAutocompleteSucursales = ({
	selectedSucursales,
	setSelectedSucursales,
	...props
}) => {
	const { data, loading } = useApi(sucursalesGet, { autoFetch: !props?.data })

	const areas = useMemo(() => {
		return props?.data ?? data?.data ?? []
	}, [data, props.data])

	useEffect(() => {
		if (typeof props.getData === "function") props.getData(data)
		if (typeof props.getLoading === "function") props.getLoading(loading)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data, loading, props?.getData, props?.getLoading])

	return (
		<InputAutocomplete
			label="Sucursales"
			options={areas}
			loading={props.loading ? props.loading : loading}
			multiple={props.multiple}
			setValue={setSelectedSucursales}
			optionsLabel="nombre"
		/>
	)
}
export default InputAutocompleteSucursales
